<template>
    <div id="DetailsWrapper">
        <div class="Button ButtonNormal NoSelect"
             style="margin-bottom: 20px;"
             @click="Back">
             戻る
        </div>

        <template v-for="entry in Details" :key="entry">
            <table class="DetailsTable">
                <thead>
                    <th>{{ `${entry.Year}部別決算【${entry.Team}】` }}</th>
                </thead>
                <tbody>
                    <tr>
                        <td></td>
                        <td></td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}" class="DataCell">
                            {{ `${data.month}月` }}
                        </td>
                    </tr>
                    <tr>
                        <td><div class="DetailsLabelCell">売上</div></td>
                        <td><div class="DetailsLabelCell"></div></td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.sales}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell">営業総益(仮)</td>
                        <td class="DetailsLabelCell"></td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.provGrossOperatingProfit}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell">ｸﾚｰﾑ調整</td>
                        <td class="DetailsLabelCell"></td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.claimAdjustment}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell">洗替実績</td>
                        <td class="DetailsLabelCell"></td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.washedResult}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell">営業総益</td>
                        <td class="DetailsLabelCell"></td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.grossOperatingProfit}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell">原価算入外経費</td>
                        <td class="DetailsLabelCell">販売コミッション</td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.salesCommission}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell"></td>
                        <td class="DetailsLabelCell">EC決済手数料</td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.ecPaymentFees}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell">売上比率で按分</td>
                        <td class="DetailsLabelCell">国内流通作業費</td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.domesticDistributionCosts}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell"></td>
                        <td class="DetailsLabelCell">倉庫保管料</td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.warehouseStorageFee}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell"></td>
                        <td class="DetailsLabelCell">出荷運賃</td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.shippingFee}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell"></td>
                        <td class="DetailsLabelCell">金型償却費</td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.moldAmortization}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell"></td>
                        <td class="DetailsLabelCell">原型償却費</td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.sculptAmortization}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell"></td>
                        <td class="DetailsLabelCell">著作権料</td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.copyrightFees}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell">原価算入外経費合計</td>
                        <td class="DetailsLabelCell"></td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${TotalNonCost(data)}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell">準営業利益</td>
                        <td class="DetailsLabelCell"></td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.quasiOperatingProfit}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell">チーム共通費</td>
                        <td class="DetailsLabelCell"></td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.teamCommonExpenses}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell">在庫金利/ﾍﾟﾅﾙﾃｨ</td>
                        <td class="DetailsLabelCell"></td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.stockPenalty}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell">減価償却</td>
                        <td class="DetailsLabelCell"></td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.depreciation}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell">事業営業利益</td>
                        <td class="DetailsLabelCell"></td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.operatingProfit}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell">人件費</td>
                        <td class="DetailsLabelCell"></td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.staffCost}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell">純利益</td>
                        <td class="DetailsLabelCell"></td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.netIncome}` }}
                        </td>
                    </tr>
                    <tr>
                        <td class="DetailsLabelCell">在庫</td>
                        <td class="DetailsLabelCell"></td>
                        <td v-for="data in entry.Data" :key="data" :class="{'GrayMonth': data.month >= CurrentMonth}">
                            {{ `${data.stock}` }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </template>
    </div>
</template>

<script>
import axios from 'axios';

export default{
    mounted(){
        this.CurrentMonth = new Date().getMonth() + 1;
        this.GetResultDetails();
    },
    methods:{
        Back()
        {
            this.$router.push('/estimations');
        },
        async GetResultDetails()
        {
            const data = {
                SessionToken: this.$GetToken(),
            };

            const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}estimation/details`, data)
            .then(async response => {
                return response.data;
            })
            .catch(error => {
                console.error('[EstimationsPage] get mikomi error', error);
            });

            console.log('Estimation details', result);

            this.Details = [];

            for (let i = 0; i < result.length; i++)
            {
                const r = result[i];

                let entry = null;

                for (let y = 0; y < this.Details.length; y++)
                {
                    if (this.Details[y].Year === r.year &&
                        this.Details[y].Team === r.teamName)
                    {
                        entry = this.Details[y];
                        break;
                    }
                }

                if (entry === null)
                {
                    entry = {
                        Year: r.year,
                        Team: r.teamName,
                        Data: []
                    };

                    this.Details.push(entry);
                }

                if (entry !== null)
                {
                    var newEntry = {};

                    for(const key in r)
                    {
                        if (this.ExcludeKey(key) === false)
                        {
                            newEntry[key] = r[key];
                        }
                    }

                    entry.Data.push(newEntry);
                }
            }

            for (let i = 0; i < this.Details.length; i++)
            {
                this.Details[i].Data = this.Details[i].Data.sort((a,b) => (a.month - b.month));
            }

            this.Details = this.Details.sort((a,b) => (b.Year - a.Year));

            console.log('details', this.Details);
        },
        ExcludeKey(key)
        {
            switch(key)
            {
                case 'id':
                case 'teamName':
                case 'year':
                case 'created_at':
                case 'updated_at':
                    return true;

                default: return false;
            }
        },
        TotalNonCost(data)
        {
            return data.salesCommission + data.ecPaymentFees + data.domesticDistributionCosts + data.warehouseStorageFee + data.shippingFee + data.moldAmortization + data.sculptAmortization + data.copyrightFees;
        }
    },
    data(){
        return {
            Details: [],
            CurrentMonth: 0,
        }
    }
}
</script>

<style lang="css" scoped>
#DetailsWrapper
{
    padding: 50px 30px;
}

.DetailsTable
{
    table-layout: fixed;
    border: 1px solid black;
    border-collapse: collapse; /* Ensures borders don't double up */

    th, td{
        border: 1px solid black; /* Full black borders like Excel */
        padding: 2px;
        text-align: center;
    }

    th {
        font-weight: bold;
        white-space: nowrap;
        padding: 4px 8px;
        border: none;
    }

    .DetailsLabelCell
    {
        width: 200px;
        max-width: 200px;
        min-width: 200px;
    }

    .DataCell
    {
        width: 60px;
    }
}

.DetailsTable + .DetailsTable
{
    margin-top: 25px;
}

.GrayMonth
{
    color: gray;
}
</style>